<template>
    <div class="container container-margin">
        <div class="row">
            <div class="col-12 content-center-aligned intro-illustration">
                <img :src="logo" class="logo">
                <img :src="introIllustration">
            </div>
        </div>
    </div>
</template>

<script>
import Logo from "@/assets/img/sisterhood-logo.svg";
import Illustration from "@/assets/img/intro-illustration.png";

export default {
    name: "IntroImage",
    data() {
        return {
            logo: Logo,
            introIllustration: Illustration
        };
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../styles/config.scss";

.intro-illustration {
    position: relative;
    margin: 60px 0px 30px !important;

    img {
        position: relative;

        max-width: calc(100% - 60px);

        &.logo {
            position: absolute;
            top: 20px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 9;
            max-width: 60%;
            height: auto;
            width: 314px;
        }

        @include respond-to("medium") {
            max-width: 100%;

            &.logo {
                max-width: 100%;
            }
        }
    }
}
</style>
